// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMessageSquareOff as RawLucideMessageSquareOff } from "lucide-react";
export const LucideMessageSquareOff = /* @__PURE__ */ createIcon(RawLucideMessageSquareOff, "LucideMessageSquareOff", 2);
